import { OnlineOrder, OrderItem, Promotion } from 'kiolyn-api';
import { cloneDeep, isEmpty } from 'lodash';
import checkIsPromotionItem from './CheckIsPromotionItem';

export default function getAvailablePromotions(
  order: OnlineOrder,
  promotions?: Promotion[]
): Promotion[] {
  if (
    order.items === undefined ||
    isEmpty(order.items) ||
    promotions === undefined ||
    isEmpty(promotions)
  ) {
    return [];
  }

  const availablePromotions = [];
  const cloneItems = getAvailableItemForPromotion(order.items, promotions);
  for (const promotion of promotions) {
    if (
      promotion.buy_items === undefined ||
      promotion.buy_quantity === undefined ||
      promotion.get_quantity === undefined
    ) {
      continue;
    }

    let buyQuantity = 0;
    for (const item of cloneItems) {
      if (item.IsPromotion) {
        continue;
      }

      for (const buyItem of promotion.buy_items) {
        if (checkIsPromotionItem(item, buyItem)) {
          buyQuantity += item.count ?? 0;
          break;
        }
      }
    }

    const cheapestPromotionCheck =
      promotion.promotion_type === 'buy_st_get_cheapest_one_free' &&
      buyQuantity >= promotion.buy_quantity + promotion.get_quantity;
    const otherPromotionCheck =
      promotion.promotion_type !== 'buy_st_get_cheapest_one_free' &&
      buyQuantity >= promotion.buy_quantity;
    if (cheapestPromotionCheck || otherPromotionCheck) {
      availablePromotions.push(promotion);
    }
  }

  return availablePromotions;
}

function getAvailableItemForPromotion(
  items: OrderItem[],
  promotions: Promotion[]
): OrderItem[] {
  const cloneItems = cloneDeep(items);
  for (const promotion of promotions) {
    if (
      promotion.buy_items === undefined ||
      promotion.buy_quantity === undefined ||
      promotion.get_quantity === undefined
    ) {
      continue;
    }

    let buyQuantity = (promotion.applied_count ?? 0) * promotion.buy_quantity;
    for (const item of cloneItems) {
      if (item.IsPromotion) {
        continue;
      }

      for (const buyItem of promotion.buy_items) {
        if (checkIsPromotionItem(item, buyItem) && item.count !== undefined) {
          if (buyQuantity >= item.count) {
            buyQuantity -= item.count;
            item.count = 0;
          } else {
            item.count -= buyQuantity;
            buyQuantity = 0;
          }
          break;
        }
      }

      if (buyQuantity === 0) {
        break;
      }
    }
  }
  return cloneItems;
}
